


import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import QuickViewModal from '../Modal/QuickViewModal';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import LoginModal from '../Modal/LoginModal';
import ProductModal from '../Modal/ProductModal';
import Noimage from '../../Images/Noimage.svg';



const getAuthToken = () => {
  const userData = sessionStorage.getItem("userData");
  if (!userData) return "";
  try {
    const parsed = JSON.parse(userData);
    return parsed.token || "";
  } catch {
    return "";
  }
};

const FeaturedProduct = () => {
  const [hoveredProduct, setHoveredProduct] = useState(null);
  const [showQuickView, setShowQuickView] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [visibleProducts, setVisibleProducts] = useState([]);
  const [mobilePage, setMobilePage] = useState(0);
  const [products, setProducts] = useState([]);
  const productsRef = useRef([]);
  const [wishlist, setWishlist] = useState([]);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const navigate = useNavigate();


  const fetchProducts = async () => {
    try {
      const token = getAuthToken();

      let axiosConfig = {};

      if (token) {
        axiosConfig = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      }


      const res = await axios.get(
        "https://vantara.datacubeglobal.com/api/featured-prods",
        axiosConfig
      );

      if (res.data.status === "success") {
        setProducts(res.data.data);
      }
    } catch (err) {
      console.error("Error fetching products:", err);
    }
  };
  useEffect(() => {
    fetchProducts();
  }, []);


  const latestProducts = [...products]
    .sort((a, b) => b.product_id - a.product_id)
    .slice(0, 4);


  // useEffect(() => {
  //   const observer = new IntersectionObserver(
  //     entries => {
  //       entries.forEach(entry => {
  //         if (entry.isIntersecting) {
  //           const id = parseInt(entry.target.dataset.id);
  //           if (!visibleProducts.includes(id)) {
  //             setVisibleProducts(prev => [...prev, id]);
  //           }
  //         }
  //       });
  //     },
  //     { threshold: 0.2 }
  //   );

  //   productsRef.current.forEach(el => el && observer.observe(el));
  //   return () => observer.disconnect();
  // }, [visibleProducts, products]);

  useEffect(() => {
    if (showQuickView) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    };
  }, [showQuickView]);

  const handleQuickAdd = (productId) => {
    const token = getAuthToken();

    if (!token) {
      setShowLoginModal(true);
      return;
    }

    const apiProduct = products.find(p => p.product_id === productId);

    if (apiProduct) {
      const formattedProduct = {
        id: apiProduct.product_id,
        name: apiProduct.product_name,
        price: parseFloat(apiProduct.special_price) || parseFloat(apiProduct.mrp),
        originalPrice: parseFloat(apiProduct.mrp),
        image: getImageUrl(apiProduct),
      };

      setSelectedProduct(formattedProduct);
      setShowQuickView(true);
    }
  };



  const handleNext = () => {
    const totalPages = Math.ceil(products.length / 2);
    setMobilePage(prev => (prev + 1) % totalPages);
  };

  const handlePrev = () => {
    const totalPages = Math.ceil(products.length / 2);
    setMobilePage(prev => (prev - 1 + totalPages) % totalPages);
  };


  // const getImageUrl = (product, idx = 0) => {
  //   if (!product.images || product.images.length === 0) return '';
  //   return `https://vantara.datacubeglobal.com/vantara/storage/app/public/${product.primary_image}`;
  // };
  const getImageUrl = (product) => {
    if (!product.primary_image) return '';
    // Ensure no duplicate slashes
    const url = `https:\/\/vantara.datacubeglobal.com\/storage/${product.primary_image.replace(/^\//, '')}`;
    // console.log('Product Image URL:', url); 
    return url;
  };

  const toggleWishlist = async (product) => {
    const token = getAuthToken();

    if (!token) {
      setShowLoginModal(true);
      return;
    }

    try {
      const res = await axios.post(
        "https://vantara.datacubeglobal.com/api/wishlist",
        { product_id: product.product_id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // If backend explicitly says Unauthenticated
      if (res.data.message === "Unauthenticated.") {
        setShowLoginModal(true);
        return;
      }

      if (res.data.status === true) {
        if (res.data.message === "Removed") {
          setWishlist(wishlist.filter((id) => id !== product.product_id));
          Swal.fire({
            toast: true,
            icon: "info",
            title: "Removed from Wishlist",
            position: "top-end",
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          });
        } else {
          setWishlist([...wishlist, product.product_id]);
          Swal.fire({
            toast: true,
            icon: "success",
            title: "Added to Wishlist",
            position: "top-end",
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          });
        }
      }
    } catch (error) {
      if (error.response?.status === 401) {
        // axios 401 fallback
        setShowLoginModal(true);
      } else {
        console.error("Error updating wishlist:", error);
        Swal.fire({
          toast: true,
          icon: "error",
          title: "Something went wrong!",
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      }
    }
  };



  return (
    <div className="container-fluid px-3 px-md-5 my-5">
      <div className="text-center mb-4">
        <h2 style={{ fontWeight: "bold", fontSize: "2rem" }}>Featured Products</h2>
        <p style={{ color: "#555", fontSize: "1.2rem" }}>
          Handpicked favorites crafted to add flavor and quality to your life.
        </p>

      </div>
      <div className="d-none d-md-block">
        <div className="row">
          {latestProducts.map((product, index) => {
            const isVisible = visibleProducts.includes(product.product_id);
            return (
              <div
                key={product.product_id}
                data-id={product.product_id}
                ref={el => productsRef.current[index] = el}
                className="col-md-6 col-lg-3 mb-4"
                style={{
                  opacity: isVisible ? 1 : 0,
                  transform: 'translateY(50px)',
                  animation: `fadeInUp 0.8s forwards ${index * 0.2}s`,
                }}
              >
                <div
                  className="card border-0 h-100"
                  onMouseEnter={() => setHoveredProduct(product.product_id)}
                  onMouseLeave={() => setHoveredProduct(null)}
                >

                  <div className="position-relative overflow-hidden" style={{ height: '450px' }}>

                    <button
                      className="position-absolute top-0 end-0 d-flex justify-content-center align-items-center"
                      onClick={() => toggleWishlist(product)}
                      style={{
                        width: '36px',
                        height: '36px',
                        borderRadius: '50%',
                        backgroundColor: '#fff',
                        border: 'none',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                        zIndex: 50,
                        cursor: 'pointer',
                        transition: 'transform 0.2s ease',
                        margin: '8px',
                        padding: 0,
                      }}
                      onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.1)'}
                      onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                    >
                      {product.is_wishlisted ? (
                        <FaHeart style={{ color: '#000' }} size={18} />
                      ) : (
                        <FaRegHeart style={{ color: '#000' }} size={18} />
                      )}
                    </button>

                    {product.special_price && product.mrp && parseFloat(product.special_price) < parseFloat(product.mrp) && (
                      <span
                        className="badge bg-danger position-absolute top-0 start-0 m-2"
                        style={{ zIndex: 50 }}
                      >
                        {`-${Math.round(100 - (parseFloat(product.special_price) / parseFloat(product.mrp)) * 100)}%`}
                      </span>
                    )}


                    <img
                      src={getImageUrl(product, 0)}
                      className="card-img-top"
                      alt={product.product_name}
                      onClick={() => navigate(`/productDetails/${product.product_id}`)}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = Noimage;
                      }}
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'opacity 0.5s ease',
                        opacity: hoveredProduct === product.product_id ? 0 : 1,
                        zIndex: 1
                      }}
                    />

                    {/* Hover Image */}
                    <img
                      src={getImageUrl(product, 1)}
                      className="card-img-top"
                      alt={product.product_name}
                      onClick={() => navigate(`/productDetails/${product.product_id}`)}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = Noimage;
                      }}
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'opacity 0.5s ease',
                        opacity: hoveredProduct === product.product_id ? 1 : 0,
                        zIndex: 2
                      }}
                    />

                    {/* QUICK ADD Button */}
                    <div
                      className="position-absolute bottom-0 start-0 end-0 d-flex justify-content-center pb-3"
                      style={{
                        opacity: hoveredProduct === product.product_id ? 1 : 0,
                        transform: hoveredProduct === product.product_id ? 'translateY(0)' : 'translateY(100%)',
                        transition: 'all 0.3s ease',
                        pointerEvents: hoveredProduct === product.product_id ? 'auto' : 'none',
                        zIndex: 10
                      }}
                    >
                      <button
                        className="btn w-100 fw-bold"
                        onClick={() => handleQuickAdd(product.product_id)}
                        style={{
                          backgroundColor: hoveredProduct === product.product_id ? '#FFFFFF' : '#FFFFFF',
                          color: hoveredProduct === product.product_id ? '#124f14' : '#124f14',
                          borderRadius: '50px',
                          transition: 'all 0.3s ease',
                          padding: '8px 24px',
                          fontSize: '0.95rem',
                          fontWeight: 'bolder'
                        }}
                      >
                        QUICK ADD
                      </button>
                    </div>
                  </div>

                  <div className="card-body text-center">
                    <h6 className="card-title text-muted mb-1" style={{ fontSize: "1.1rem", fontWeight: "500" }}>
                      {product.product_name}
                    </h6>
                    <div className="d-flex justify-content-center align-items-center">
                      {/* Show strike-through MRP only if special_price < mrp */}
                      {product.mrp &&
                        product.special_price &&
                        parseFloat(product.special_price) < parseFloat(product.mrp) && (
                          <span
                            className="text-muted text-decoration-line-through me-2"
                            style={{ fontSize: "12px" }}
                          >
                            ₹{product.mrp}
                          </span>
                        )
                      }

                      {/* Show price (special_price if present, else mrp) */}
                      <span className="fw-bold" style={{ fontSize: "14px", color: "#7c0046" }}>
                        ₹
                        {product.special_price
                          ? parseFloat(product.special_price) < parseFloat(product.mrp)
                            ? product.special_price 
                            : product.special_price 
                          : product.mrp}        
                      </span>

                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="d-md-none">
        <div className="position-relative">
          <div className="d-flex overflow-hidden">
            {products.map((product, index) => {
              const start = mobilePage * 2;
              const end = start + 2;
              if (index < start || index >= end) return null;
              return (
                <div key={product.product_id} className="flex-shrink-0 me-2" style={{ width: '48%' }}>
                  <div className="card border-0 shadow-sm h-100">
                    <div className="position-relative overflow-hidden" style={{ height: '260px' }}>
                      {product.special_price && product.mrp && parseFloat(product.special_price) < parseFloat(product.mrp) && (
                        <span className="badge bg-danger position-absolute top-0 start-0 m-2">
                          {`-${Math.round(100 - (parseFloat(product.special_price) / parseFloat(product.mrp)) * 100)}%`}
                        </span>
                      )}
                      <span
                        className="position-absolute top-0 end-0 m-2"
                        style={{
                          zIndex: 5,
                          padding: '4px',
                          cursor: 'pointer',
                        }}
                        onClick={() => navigate('/productDetails')}
                      >
                        <i className="bi bi-eye fs-5" style={{ color: '#000' }}></i>
                      </span>
                      <img
                        src={getImageUrl(product, 0)}
                        className="card-img-top"
                        alt={product.product_name}
                        onClick={() => navigate(`/productDetails/${product.product_id}`)}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = Noimage;
                        }}
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          transition: 'opacity 0.5s ease',
                          opacity: hoveredProduct === product.product_id ? 0 : 1
                        }}
                      />
                      <img
                        src={getImageUrl(product, 1)}
                        className="card-img-top"
                        alt={product.product_name}
                        onClick={() => navigate(`/productDetails/${product.product_id}`)}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = Noimage;
                        }}
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          transition: 'opacity 0.5s ease',
                          opacity: hoveredProduct === product.product_id ? 1 : 0
                        }}
                      />
                      <div className="position-absolute bottom-0 start-0 end-0 d-flex justify-content-center pb-3">
                        <button
                          className="btn w-100 fw-semibold"
                          onClick={() => handleQuickAdd(product.product_id)}
                          style={{
                            backgroundColor: hoveredProduct === product.product_id ? '#FFFFFF' : '#FFFFFF',
                            color: hoveredProduct === product.product_id ? '#124f14' : '#124f14',
                            borderRadius: '50px',
                            transition: 'all 0.3s ease',
                            padding: '8px 24px',
                            fontSize: '0.95rem'
                          }}
                        >
                          QUICK ADD
                        </button>
                      </div>
                    </div>
                    <div className="card-body text-center">
                      <h6 className="card-title" style={{ fontSize: '14px' }}>{product.product_name}</h6>
                      <div className="d-flex justify-content-center align-items-center">
                    
                        {product.mrp &&
                          product.special_price &&
                          parseFloat(product.special_price) < parseFloat(product.mrp) && (
                            <span
                              className="text-muted text-decoration-line-through me-2"
                              style={{ fontSize: "12px" }}
                            >
                              ₹{product.mrp}
                            </span>
                          )
                        }

                    
                        <span className="fw-bold" style={{ fontSize: "14px", color: "#7c0046" }}>
                          ₹
                          {product.special_price
                            ? parseFloat(product.special_price) < parseFloat(product.mrp)
                              ? product.special_price 
                              : product.special_price 
                            : product.mrp}        
                        </span>

                        {/* <span className="fw-bold text-dark" style={{ fontSize: '14px' }}>{`₹${product.special_price || product.mrp}`}</span> */}
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
          <div className="d-flex justify-content-center mt-2">
            {Array.from({ length: Math.ceil(products.length / 2) }).map((_, idx) => (
              <span
                key={idx}
                className={`mx-1 rounded-circle`}
                style={{
                  width: '10px',
                  height: '10px',
                  backgroundColor: mobilePage === idx ? '#000' : '#ccc',
                  display: 'inline-block',
                  cursor: 'pointer'
                }}
                onClick={() => setMobilePage(idx)}
              ></span>
            ))}
          </div>
          <div className="position-absolute top-50 start-0 translate-middle-y">
            <button className="btn btn-light btn-sm" onClick={handlePrev}>❮</button>
          </div>
          <div className="position-absolute top-50 end-0 translate-middle-y">
            <button className="btn btn-light btn-sm" onClick={handleNext}>❯</button>
          </div>
        </div>
      </div>
      <style>{`
  @keyframes fadeInUp {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`}</style>

      {showLoginModal && (
        <LoginModal
          show={showLoginModal}
          handleClose={() => setShowLoginModal(false)}
          handleLoginSuccess={(userData) => {

            // localStorage.setItem("auth_token", userData.token);
            setShowLoginModal(false);
          }}
        />
      )}
      <ProductModal show={showQuickView} onHide={() => {
        setShowQuickView(false);
        fetchProducts();
      }}
        product={selectedProduct} />
    </div>
  );
};

export default FeaturedProduct;